<p-sidebar class="right-menu-sidebar " [(visible)]="visible" position="right"
    [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
    [styleClass]="isFullWidth ? 'w-full' : 'w-full sm:w-27rem sm:max-w-27rem'">

    <div class="sticky top-0 z-1 bg-white ">
        <div class="flex justify-content-between align-items-center mt-1 ">
            <div class="title title-service" id="title-nouveaute">{{'nouveaute.title' | translate}}</div>
            <button (click)="toggleFullscreenSidebar()" pButton type="button" [icon]="isFullWidth ? 'pi pi-window-minimize' : 'pi pi-external-link'"
                class="p-button-sm p-button-text p-button-rounded p-button-secondary hidden sm:block center-icon"></button>
        </div>
    </div>
    <hr>
    <lib-menu-nouveautes [configuration]="configuration" [isFullWidth]="isFullWidth"></lib-menu-nouveautes>
</p-sidebar>